import { render, staticRenderFns } from "./GuardianManual.vue?vue&type=template&id=731c67e4"
import script from "./GuardianManual.vue?vue&type=script&lang=js"
export * from "./GuardianManual.vue?vue&type=script&lang=js"
import style0 from "./GuardianManual.vue?vue&type=style&index=0&id=731c67e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports